<template>
  <div>
    <FilterForm
      :formData="filterData"
      :filters="filters"
      @changeDept="changeDept"
      @submit="handleFilterSubmit"
      @reset="handleReset"
    />
    <div class="system-btn user-btn">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="handleNew"
      >添加贷后提醒</el-button>
<!--      <el-button
        size="small"
        @click="downloadExcel"
      >导出数据</el-button>-->
    </div>
    <div class="container">
      <div class="right">
        <RoleTable
          v-if="tableData"
          :tableColumn="tableColumn"
          :tableData="tableData"
          @edit="goToEdit"
        />
        <RolePagination
          :total="total"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
        />
      </div>
    </div>
    <RoleDialog
      :title="title"
      :isShowDialog="isShowDialog"
      :forms="forms"
      :formData="formData"
      :width="800"
      @submit="handleSubmit"
      @close="handleColse"
    />

  </div>

</template>

<script>
import FilterForm from "@/components/filter";
import { computed, onMounted, reactive, ref } from "vue";
import { ElButton, ElInput, ElMessage, ElTree } from "element-plus";
import { tableColumn, forms } from "./index.js";
import RoleTable from "@/components/table";
import RolePagination from "@/components/pagination";
import RoleDialog from "@/components/dialog-form";
import { useStore } from "vuex";
import {
  putWorkReport,
} from "@/api/method/report";

import {
  postFollowUp,
  getFollowUp
} from "@/api/method/follow-up";
import { getUserByDept } from "@/api/method/common";
import { reset } from "@/until";

export default {
  name: "SystemRole",
  components: {
    FilterForm,
    [ElButton.name]: ElButton,
    [ElInput.name]: ElInput,
    [ElTree.name]: ElTree,
    RoleTable,
    RolePagination,
    RoleDialog,
  },
  setup() {
    const { dispatch, state } = useStore();

    const formData = reactive({
      id: null,
      remindTime: null,
      content: null,
      customerId: null,
      startTime: null,
      endTime: null
    });
    const filterData = reactive({
      customerId: null,
      customerName: null
    });
    const filters = reactive([
      [
        {
          type: 'input',
          attr: 'customerId',
          placeholder: '客戶号',
          column: 8,
          labelWidth: '96px'
        },
        {
          type: 'input',
          attr: 'customerName',
          placeholder: '客戶名',
          column: 8,
          labelWidth: '96px'
        },
        {
          type: "button",
          column: 4,
        },
      ],
    ]);

    const getDepartList = async () => {
      await dispatch("departmentList");
      filters[0][0].option = state.departmentList.map((item) => ({
        label: item.fullName,
        val: item.id,
      }));
    };
    const changeDept = async (id) => {
      const res = await getUserByDept(id);
      filters[0][1].option = res.data.map((item) => ({
        label: item.nickname,
        val: item.id,
      }));
    };

    const pagination = reactive({
      page: 1,
      size: 10,
    });

    const company = ref("");
    const tableData = computed(() => state.followUpList && state.followUpList.records);
    const total = computed(() => state.followUpList && state.followUpList.total);
    const treeData = computed(() => state.menuTree);

    const isShowDialog = ref(false);
    const title = ref("添加贷后提醒（每还款周期前3天提醒）");

    const handleNew = () => {
      isShowDialog.value = true;
    };
    const handleColse = () => {
      isShowDialog.value = false;
      reset(formData);
      formData.type = 1;
    };

    const getList = () => {
      const { date, ...param } = filterData;

      const startTime = date && date[0];
      const endTime = date && date[1];
      dispatch("followUpList", { ...pagination, ...param, startTime, endTime });
    };

    onMounted(() => {
      getList();
      getDepartList();
      //   getDepartTree();
      //   getRoleList();
    });
    const currentChange = (page) => {
      pagination.page = page;
      getList();
    };
    const sizeChange = (size) => {
      pagination.size = size;
      getList();
    };
    const idArr = ref([]);
    const handleSelectionChange = (arr) => {
      idArr.value = arr.map((item) => item.id);
    };

    const handleNodeClick = () => {};

    const handleSubmit = async () => {
      const { id, ...params } = formData;
      if (id) {
        const res = await putWorkReport({ id, ...params });
        if (res.code == 200) {
          ElMessage.success("编辑成功！");
          handleColse();
          getList();
        } else {
          ElMessage.error(res.msg);
        }
      } else {
        const res = await postFollowUp(params);
        if (res.code == 200) {
          ElMessage.success("保存成功！");
          handleColse();
          getList();
        } else {
          ElMessage.error(res.msg);
        }
      }
    };
    const getWorkDetail = async (id) => {
      const res = await getFollowUp(id);
      const {
        remindTime,
        content,
        customerId,
        startTime,
        endTime
      } = res.data;
      formData.id = id;
      formData.remindTime= remindTime,
      formData. content = content,
      formData.customerId = customerId,
      formData.startTime =startTime,
      formData.endTime = endTime
    };
    const goToEdit = async (id) => {
      isShowDialog.value = true;
      title.value = "编辑";

      getWorkDetail(id);
    };

    const handleFilterSubmit = () => getList();
    const handleReset = () => {
      reset(filterData);
      getList();
    };

    const downloadExcel = () => {};

    return {
      filters,
      filterData,
      company,
      tableColumn,
      tableData,
      handleNew,
      isShowDialog,
      forms,
      formData,
      total,
      handleSelectionChange,
      treeData,
      handleNodeClick,
      handleSubmit,
      handleColse,
      title,
      goToEdit,
      changeDept,
      handleFilterSubmit,
      handleReset,
      downloadExcel,
      currentChange,
      sizeChange,
    };
  },
};
</script>

<style lang="scss" scoped>
.user-btn {
  padding-bottom: 40px;
}
.container {
  display: flex;
  height: auto;
  .left {
    width: 250px;
    background: #f5f6f9;
    margin-right: 24px;
    padding: 20px;
  }
  .right {
    flex: 1;
    background-color: #fff;
    overflow: hidden;
  }
}
</style>

<style lang="scss">
.company-block {
  margin-bottom: 20px;
}

.company-block .el-input__inner {
  background: white !important;
}
.depart-tree {
  background: #f5f6f9;
  .el-tree-node__content {
    background: #f5f6f9;
  }
}
</style>
